import React, { Component } from "react";
import "./NodeManager.css";
import "./NetworksDashboard.css";
import axios from "axios";
import "react-notifications-component/dist/theme.css";
import "animate.css";
import NetworkCard from "./NetworkCard";
import NetworkAddModal from "./NetworkAddModal";
import { store } from "react-notifications-component";
import { GlobalFilter } from "./GlobalFilter";

import RemoveModal from "./RemoveModal";

class NetworksDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loaded: false,
      userInfo: {},
      filter: "",
      validationErrors: [],
      newNetwork: {
        name: "",
        description: "",
      },
      leaveNetwork: {
        body: "",
        header: "",
        button: "",
      },
      networkAddModal: false,
      editing: false,
    };
  }
  componentDidMount() {
    this.getUserInfo();
  }

  renderErrors = () => {
    const validationErrors = this.state.validationErrors;
    const error_tags = ["name"];

    let errors = [];

    for (var i = 0; i < error_tags.length; i++) {
      let error_msg = validationErrors[error_tags[i]];
      if (error_msg) {
        errors.push(<li key={error_tags[i]}>{error_msg}</li>);
      }
    }

    return errors;
  };

  toggleModal = (toggle) => {
    if (this.state[toggle]) {
      this.setState({ validationErrors: [] });
    }

    this.setState({ [toggle]: !this.state[toggle] });
  };

  getHeaders = () => {
    return {
      Authorization: `Token ${this.props.token}`,
    };
  };

  getUserInfo = () => {
    axios
      .get(this.props.baseUrl + "/api/api/users/me/", {
        headers: this.getHeaders(),
      })
      .then((res) => {
        this.setState({ userInfo: res.data });
        this.setState({ loaded: true });
      })
      .catch((err) => {});
  };

  createNetwork = (network) => {
    const formData = new FormData();
    formData.append("name", network.name);
    formData.append("description", network.description);
    formData.append("users", this.state.userInfo.username);
    formData.append("admins", this.state.userInfo.username);

    axios
      .post(this.props.baseUrl + "/api/api/network/", formData, {
        headers: this.getHeaders(),
      })
      .then((response) => {
        this.getUserInfo();
        this.notify_create();
        this.setState({ validationErrors: [] });
        this.toggleModal("networkAddModal");
      })
      .catch((errors) => {
        this.setState({ validationErrors: errors.response.data });
      });
    return;
  };

  renderNetworks = () => {
    let nerwork_cards = [];
    let networks = this.state.userInfo.profile.networks;
    for (var i = 0; i < networks.length; i++) {
      let network = networks[i];
      if (
        this.state.filter === "" ||
        network.name.toLowerCase().includes(this.state.filter) ||
        network.description.toLowerCase().includes(this.state.filter)
      ) {
        nerwork_cards.push(
          <NetworkCard
            baseDir={this.props.baseDir}
            editing={this.state.editing}
            key={network.uuid}
            network={network}
            setLeaveModal={this.setLeaveModal}
            setDeleteModal={this.setDeleteModal}
          />
        );
      }
    }
    if (nerwork_cards.length === 0) {
      nerwork_cards.push(<h4 key="No_nwrk" style={{ color: "white" }}>No Networks Found</h4>);
    }
    return nerwork_cards;
  };

  setFilter = (fltr) => {
    this.setState({ filter: fltr });
  };

  toggleModal = (toggle) => {
    if (this.state[toggle]) {
      this.setState({ validationErrors: [] });
    }

    this.setState({ [toggle]: !this.state[toggle] });
  };

  leaveNetwork = async (network) => {
    const formData = new FormData();
    formData.append("remove-users", this.state.userInfo.email);
    formData.append("_method", "PATCH");

    this.setState({ leaveNetworkModal: false });

    axios
      .patch(
        this.props.baseUrl +
          "/api/api/network/" +
          this.state.editNetwork.uuid +
          "/users/",
        formData,
        {
          headers: this.getHeaders(),
        }
      )
      .then((response) => {
        window.location = this.props.baseUrl+"/networks/";
      })
      .catch((errors) => {
        this.setState({ validationErrors: errors.response.data });
      });
    return;
  };

  setLeaveModal = (network) => {
    var leaveNetwork = { ...this.state.leaveNetwork };

    let admins = network.admins;
    let user = this.props.user;

    // User is last admin
    if (admins.includes(user) && admins.length === 1) {
      leaveNetwork.header = "Cannot leave network";
      leaveNetwork.body = (
        <>
          You are the last admin in the network.
          <br />{" "}
          <b>
            Please grant admin rights to at least one other user to be able to
            leave the network.
          </b>
        </>
      );
      leaveNetwork.button = "";
    }

    // User is not last admin, leave warning that user nodes will be removed
    else {
      leaveNetwork.header = "Leave network";
      leaveNetwork.body = (
        <>
          Are you sure you want to leave the network?
          <br />
          <b>
            Leaving will permanently delete any remaining nodes that you own.
          </b>
        </>
      );
      leaveNetwork.button = "Leave network";
    }

    this.setState({ leaveNetwork });
    this.setState({ editNetwork: network });
    this.setState({ leaveNetworkModal: true });
  };

  setDeleteModal = (network) => {
    this.setState({ editNetwork: network });
    this.setState({ deleteNetworkModal: true });
  };

  render() {
    return (
      <div className="networks">
        <div className="networks_title">
          <h1>My networks</h1>
        </div>
        <div className="header_area">
          <GlobalFilter filter={this.state.filter} setFilter={this.setFilter} placeholder="Filter networks"/>
          <div className="header_button_area">
            <button
              className={`create_network_button ${
                this.state.editing && "editing"
              }`}
              onClick={() => {
                this.setState({ editing: !this.state.editing });
              }}
            >
              Edit
            </button>
            <button
              className="create_network_button"
              disabled={this.state.editing}
              onClick={() => {
                this.setState({ networkAddModal: true });
              }}
            >
              Create network
            </button>
          </div>
        </div>
        <div className="network_cards">
          {this.state.loaded ? this.renderNetworks() : null}
        </div>
        {this.state.networkAddModal ? (
          <NetworkAddModal
            toggle={this.toggleModal}
            toggleName="networkAddModal"
            network={this.state.newNetwork}
            onSave={this.createNetwork}
            getErrors={this.renderErrors}
          />
        ) : null}
        {this.state.leaveNetworkModal ? (
          <RemoveModal
            toggle={this.toggleModal}
            toggleName="leaveNetworkModal"
            onSave={this.leaveNetwork}
            message_body={this.state.leaveNetwork.body}
            message_header={this.state.leaveNetwork.header}
            saveButton={this.state.leaveNetwork.button}
          />
        ) : null}
        {this.state.deleteNetworkModal ? (
          <RemoveModal
            toggle={this.toggleModal}
            toggleName="deleteNetworkModal"
            onSave={this.leaveNetwork}
            message_body={
              <>
                Are you sure you want to delete the network?
                <br />
                <b>
                  This action will delete any remaining nodes and the network
                  permanently.
                </b>
              </>
            }
            message_header={"Delete Network"}
            saveButton={"Delete Network"}
          />
        ) : null}
      </div>
    );
  }

  notify_create = () => {
    store.addNotification({
      title: "Success!",
      type: "success",
      message: "Network created",
      insert: "top",
      container: "top-right",
      animationIn: ["animate__animated", "animate__fadeIn"],
      animationOut: ["animate__animated", "animate__fadeOut"],
      dismiss: {
        duration: 5000,
        onScreen: true,
        showIcon: true,
      },
    });
  };
}

export default NetworksDashboard;
